import { useEffect, useState } from 'react';
import Reveal from '@/components/base/Reveal';

export default function TipSection() {
  const [open, setOpen] = useState(false);
  const [sent, setSent] = useState(false);
  const [content, setContent] = useState('');

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  const close = () => {
    setOpen(false);
    setSent(false);
    setContent('');
  };

  return (
    <section id="tip" className="relative w-full overflow-hidden bg-background-950 py-16 md:py-24">
      <div className="absolute inset-0 opacity-25">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20texture%20of%20folded%20newspaper%20and%20warm%20red%20spotlight%20beams%2C%20editorial%20background%2C%20deep%20crimson%20and%20amber%20glow%2C%20cinematic%20grain%2C%20no%20figures%2C%20no%20text&width=1600&height=900&seq=psg-tip-bg&orientation=landscape"
          alt="爆料入口背景氛围图"
          title="私照外泄 爆料入口"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/80 to-foreground-950/95" />

      <div className="relative mx-auto w-full max-w-4xl px-4 text-center md:px-8">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/20 bg-background-50/10 px-4 py-1.5 text-xs font-medium text-background-100 md:text-sm">
            <i className="ri-send-plane-line text-base text-accent-400" />
            爆料通道 · 24 小时开放
          </span>
          <h2 className="mt-6 font-heading text-2xl font-black text-background-50 md:text-4xl">
            你手上的线索，可能正是下一块拼图
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-background-300 md:text-base">
            如果你掌握公开可查证的信息，欢迎通过下方入口提交线索。我们会先做真实性核对，再决定是否补充进时间线。
          </p>
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <button
              type="button"
              onClick={() => setOpen(true)}
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto md:text-base"
            >
              <i className="ri-pushpin-2-line text-lg" />
              我要爆料
            </button>
            <a
              href="#timeline"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 bg-background-50/10 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/20 sm:w-auto md:text-base"
            >
              <i className="ri-refresh-line text-lg" />
              查看最新进展
            </a>
          </div>
        </Reveal>
      </div>

      {open && (
        <div className="fixed inset-0 z-[60] flex items-end justify-center bg-foreground-950/70 p-0 backdrop-blur-sm sm:items-center sm:p-6">
          <div className="w-full max-w-lg rounded-t-lg border border-background-200 bg-background-50 p-6 sm:rounded-lg md:p-7">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h3 className="font-heading text-xl font-black text-foreground-950">提交爆料线索</h3>
                <p className="mt-1.5 text-xs text-foreground-500 md:text-sm">
                  演示页面，内容不会被真实提交或公开
                </p>
              </div>
              <button
                type="button"
                onClick={close}
                aria-label="关闭"
                className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-600 transition-colors hover:bg-background-100 hover:text-foreground-900"
              >
                <i className="ri-close-line text-xl" />
              </button>
            </div>

            {sent ? (
              <div className="mt-6 flex flex-col items-center rounded-lg border border-secondary-200 bg-secondary-50 px-6 py-9 text-center">
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className="ri-check-double-line text-3xl" />
                </span>
                <p className="mt-4 font-heading text-lg font-bold text-foreground-950">线索已记录</p>
                <p className="mt-2 text-sm text-foreground-600">
                  感谢你的补充，我们会先核实，再决定是否更新到时间线。
                </p>
                <button
                  type="button"
                  onClick={close}
                  className="mt-6 whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  完成
                </button>
              </div>
            ) : (
              <div className="mt-6 flex flex-col gap-4">
                <label className="flex flex-col gap-2">
                  <span className="text-sm font-semibold text-foreground-800">线索类型</span>
                  <select className="rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200">
                    <option>现场 / 时间地点线索</option>
                    <option>传播链与转发路径</option>
                    <option>公开回应与声明</option>
                    <option>内幕说法（待核实）</option>
                  </select>
                </label>
                <label className="flex flex-col gap-2">
                  <span className="text-sm font-semibold text-foreground-800">线索描述</span>
                  <textarea
                    value={content}
                    maxLength={500}
                    onChange={(e) => setContent(e.target.value)}
                    rows={4}
                    placeholder="请尽量描述时间、地点与可公开查证的来源"
                    className="resize-none rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                  />
                  <span className="self-end text-xs text-foreground-400">{content.length}/500</span>
                </label>
                <button
                  type="button"
                  onClick={() => setSent(true)}
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-send-plane-fill text-base" />
                  提交线索
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
}